import { defineMessages } from "react-intl"

export default defineMessages({
  headerLanguage: {
    id: "app.components.Language.headerLanguage",
  },
  languages: {
    id: "app.components.Language.languages",
  },
  'languages.English': {
    id: "app.components.Language.languages.English",
  },
  'languages.French': {
    id: "app.components.Language.languages.French",
  },
  'languages.German': {
    id: "app.components.Language.languages.German",
  },
  'languages.Chinese': {
    id: "app.components.Language.languages.Chinese",
  },
  'languages.Japanese': {
    id: "app.components.Language.languages.Japanese",
  },
  questions: {
    id: "app.components.Language.questions",
  },
  listening: {
    id: "app.components.Language.listening",
  },
  speaking: {
    id: "app.components.Language.speaking",
  },
  reading: {
    id: "app.components.Language.reading",
  },
  writing: {
    id: "app.components.Language.writing",
  },
})
